import { Routes } from '@angular/router';
import { WizardSinistroComponent } from './components/wizard-sinistro/wizard-sinistro';

export const routes: Routes = [
  { path: '', component: WizardSinistroComponent },
  { path: ':targa', component: WizardSinistroComponent },
  { path: '**', redirectTo: '' }
];
